import { render, staticRenderFns } from "./WaitingDots.vue?vue&type=template&id=4ac50588&scoped=true"
import script from "./WaitingDots.vue?vue&type=script&lang=ts&setup=true"
export * from "./WaitingDots.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./WaitingDots.vue?vue&type=style&index=0&id=4ac50588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac50588",
  null
  
)

export default component.exports